const calculateEnabledStatus = (behavior, enableWhen, values) => enableWhen?.[behavior === 'any' ? 'some' : 'every'](item => {
    if (Array.isArray(values[item.question])) {
        // If it's an array, check if any (or all, depending on behavior) of the elements in the array satisfy the condition
        return values[item.question][behavior === 'any' ? 'some' : 'every'](value => item.operator === '=' && item.answerCoding.code === value);
    }
    return item.operator === '=' && item.answerCoding.code === values[item.question];
});

export default calculateEnabledStatus;